<template>
  <div class="home" style="min-width: 650px; overflow: hidden">
    <!-- 常规Loading -->
    <div v-loading.fullscreen.lock="mainloading" :element-loading-background="'rgba(0,0,0,0.4)'"
      element-loading-text="请稍后..."></div>
    <div :class="isshow ? 'home-l' : 'home-l2'">
      <div class="hl-top">
        <div v-show="!isshow" style="
            width: 40px;
            height: 40px;
            margin: 20px auto 0;
            border-radius: 20px;
            overflow: hidden;
          ">
          <img src="../assets/img/jxslogo2.png" style="width: 40px; height: 40px" />
        </div>
        <div class="hlt-name" v-show="isshow">网云经销商</div>
        <div class="hlt-time" v-show="isshow">
          <div style="line-height: 15px">当前版本：</div>
          <div style="line-height: 15px">{{ viewVersion }}</div>
          <div class="hl-fixe4"></div>
        </div>
      </div>
      <div class="hl-mitem" v-for="(i, index) in toolList" :key="index" @click="toBG(i.name)">
        <i class="iconfont htool" :class="i.icon"></i>
        <div v-show="isshow" style="padding-left: 10px">{{ i.title }}</div>
        <div class="icon-act">◆</div>
        <div :class="i.class">
          <div v-for="(i1, index1) in i.children" :key="index1" class="hlmig-item"
          :style="{width: i1.type == 'report' ? 'auto' : '150px','white-space': i1.type == 'report' ? '' : 'nowrap'}">
            <div class="hlmigi-title">{{ i1.name }}</div>
            <div v-for="(i2, index2) in i1.list" :key="index2" class="hlmigi-i" @click="toPage(i2)">
              {{ i2.name }}
              <i class="iconfont tool-hot" v-if="i2.ishot" style="margin-left: 5px; font-size: 16px"></i>
              <span v-if="i2.fnaviid == 2111" style="font-size: 12px; color: #4283fb"
                @click.stop="toPage({ name: '快速报价', code: 'ksbj', fnaviid: 2112 })">（快速报价）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="hl-bottom" v-show="isshow">
        <div>网云技术出品</div>
        <div>NetCloud Technology</div>
      </div>
      <div class="hl-fixe" @click="changeIsshow">
        <i class="iconfont" style="font-size: 20px" :class="isshow ? 'htoolsq' : 'htoolzk'"></i>
      </div>
      <div class="hl-fixe2"></div>
      <div class="hl-fixe3"></div>
    </div>
    <!-- 第二部分 -->
    <div class="home-r" :style="{ width: mainWidth + 'px' }">
      <div class="hr-top">
        <div class="hrt-l">
          {{ company.linkname }}
        </div>
        <div class="hrt-r">
          <div class="hrtr-item userinfo">
            <div class="userimg"><img :src="userImg" /></div>
            <div class="username">{{ userinfo.fnickname }}{{ userinfo.fmobile }}</div>
            <div class="usericon" style="height: 60px; cursor: pointer">
              <el-dropdown trigger="click" @command="handleCommand1"
                style="outline: none; border: none; overflow: hidden; width: 30px">
                <div class="dropdown">
                  <i class="iconfont icon_xiangxia"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="closeNow">登录时间：{{ loginTime }}</el-dropdown-item>
                  <!-- <el-dropdown-item command="erpCom">挂靠企业</el-dropdown-item>
                  <el-dropdown-item command="kcmCom">绑定KCM</el-dropdown-item>
                  <el-dropdown-item command="bossQuit">退出团队</el-dropdown-item> -->
                  <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
                  <el-dropdown-item command="changeColor">更改主题</el-dropdown-item>
                  <el-dropdown-item command="changename">更改昵称</el-dropdown-item>
                  <el-dropdown-item>
                    <div style="position: relative; height: 38px">
                      更换头像
                      <el-upload action="" accept="image/png" :on-change="onUploadChange" :auto-upload="false"
                        :show-file-list="false">
                        <el-button slot="trigger" size="small" type="primary" style="
                            position: absolute;
                            top: 0;
                            left: 0;
                            height: 40px;
                            width: 230px;
                            opacity: 0;
                          ">更换头像</el-button>
                      </el-upload>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="hrtr-item tb-group" v-if="company.linkid == '2100000000001'">
            <div class="top-btn1" :style="'border:' + ssbgcolor + ' 1px solid;color:' + ssbgcolor">
              试用
            </div>
            <div class="top-btn2" :style="'border:' + ssbgcolor + ' 1px solid;background-color:' + ssbgcolor">
              购买
            </div>
          </div>
          <div class="hrtr-item curp" @click="toHelp">
            <i class="iconfont right-t tool-help"></i>帮助中心
          </div>
          <div class="hrtr-item curp">
            <i class="iconfont right-t tel2"></i><a
              href="tencent://message/?uin=402898490&Site=Sambow&Menu=yes">技术支持</a>
          </div>
          <div class="hrtr-item curp" @click="loginOut">
            <i class="iconfont right-t hoolc"></i>
          </div>
        </div>
      </div>
      <div class="hr-top2">
        <div :class="
            historyIndex == -1 || historyList.length == 0 ? 'acthis-item' : 'his-item'
          " :style="
            historyIndex == -1 || historyList.length == 0 ? 'background:' + ssbgcolor : ''
          " @click="toHome">
          首页
        </div>
        <div v-for="(i, index) in historyList" :key="i.code"
          :class="historyIndex == index ? 'acthis-item1' : 'his-item1'"
          :style="historyIndex == index ? 'background:' + ssbgcolor : ''" @click="historyTo(i, index)">
          <span class="his-name">{{ i.name }}</span>
          <i class="iconfont hisgb" style="font-size: 14px" @click.stop="closeOne(i, index)"></i>
        </div>
        <div style="width: 30px">
          <el-dropdown trigger="click" @command="handleCommand"
            style="outline: none; border: none; overflow: hidden; width: 30px">
            <div class="dropdown">
              <i class="iconfont icon_xiangxia"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
              <el-dropdown-item command="closeNow">关闭当前</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="hr-main" :style="{ height: screenHeight - 95 + 'px' }">
        <keep-alive>
          <router-view ref="rout" :newlist="historyList" :screenWidth="screenWidth" :screenHeight="screenHeight"
            v-if="$route.meta.keepAlive" @toadd="toAddzl" @topage="useoftenTo" @topage2="useoftenTo2"
            @closeCurrentPage="closeCurrentPage" />
        </keep-alive>
        <router-view ref="rout1" :newlist="historyList" v-if="!$route.meta.keepAlive" @closeCurrentPage="closeCurrentPage" @topage="useoftenTo" />
      </div>
    </div>
    <vxe-modal v-model="showcolor" width="200" height="100" title="选择颜色">
      <div class="models">
        <div class="model-b">
          <el-color-picker v-model="ssbgcolor1"></el-color-picker>
          <div>
            <vxe-button size="mini" status="info" content="取消" @click="cancelColor"></vxe-button>
            <vxe-button size="mini"
              :style="'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1 + ';color: #fff;'"
              @click="comfirmColor" content="确认"></vxe-button>
          </div>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal v-model="showxtpz">
      <template>
        <div style="font-size: 16px; margin-bottom: 10px">请输入模块密码：</div>
        <div class="model-b" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          ">
          <vxe-input v-model="xtpzcode" placeholder="请输入" style="margin: 0 5px; width: 230px" />
          <vxe-button status="primary" :style="'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1"
            @click="comfirmxtpz" content="确认"></vxe-button>
          <vxe-button content="取消" @click="cancelxtpz"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showkcmCom" title="绑定kcm">
      <template>
        <div class="model-b" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          ">
          <div>用户名称:</div>

          <vxe-input v-model="kcmComObj.fusername" placeholder="请输入" style="margin: 0 5px; flex: 1" />
        </div>
        <div class="model-b" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          ">
          <div>经办业务:</div>

          <vxe-input v-model="kcmComObj.fworkername" placeholder="请输入" style="margin: 0 5px; flex: 1" />
        </div>
        <div class="model-b" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          ">
          <div>往来单位:</div>

          <vxe-input v-model="kcmComObj.fcsname" placeholder="请输入" style="margin: 0 5px; flex: 1" />
        </div>
        <div style="text-align: right">
          <vxe-button status="primary" :style="'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1"
            :disabled="hasKcm" @click="comfirmKcm" content="绑定关系"></vxe-button>
          <vxe-button content="解除关系" @click="comfirmKcm2" :disabled="!hasKcm"></vxe-button>
          <vxe-button content="设置用户" @click="showkcmUser" :disabled="!hasKcm"></vxe-button>
          <vxe-button content="关闭" @click="cancelKcm"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="iskcmUser" width="720" height="600" title="绑定用户">
      <template>
        <div>所有用户(双击添加)</div>
        <div class="model-b" style="
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            width: 670px;
            height: 150px;
          ">
          <div v-for="(item, index) in userListAll" @dblclick="addListOne(item)" :key="index" style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            ">
            <div>{{ item.fnickname }}</div>
            <div style="font-size: 12px; color: #888">{{ item.fmobile }}</div>
          </div>
        </div>
        <div>已包含用户(双击删除)</div>
        <div class="model-b" style="
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            width: 670px;
            height: 150px;
          ">
          <div v-for="(item, index) in userListhave" @dblclick="delListOne(item)" :key="index" style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            ">
            <div>{{ item.fusername }}</div>
            <div style="font-size: 12px; color: #888">{{ item.fuserid }}</div>
          </div>
        </div>
        <div>待添加用户(双击移除)</div>
        <div class="model-b" style="display: flex; margin-bottom: 10px; height: 30px">
          <div v-for="(item, index) in userListtoadd" @dblclick="deladdtOne(index)" :key="index" style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            ">
            <div>{{ item.fnickname }}</div>
          </div>
        </div>
        <div>待删除用户(双击移除)</div>
        <div class="model-b" style="display: flex; margin-bottom: 10px; height: 30px">
          <div v-for="(item, index) in userListtodel" @dblclick="deldeltOne(index)" :key="index" style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            ">
            <div>{{ item.fusername }}</div>
          </div>
        </div>
        <div style="text-align: right">
          <vxe-button :style="'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1" content="保存"
            @click="savekcmUser"></vxe-button>
          <vxe-button content="关闭" @click="closekcmUser"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showerpCom" width="680" height="400" title="挂靠企业">
      <template>
        <div style="
            border-bottom: 1px solid #888;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 0;
          ">
          当前挂靠企业：{{ erpComObj.fname }}
          <vxe-button content="退出当前企业" @click="erpcomClick('1')"></vxe-button>
        </div>
        <div class="model-b" style="display: flex; justify-content: space-between">
          <div style="
              border-right: 1px solid #888;
              width: 190px;
              height: 280px;
              padding: 0 5px;
            ">
            <vxe-input v-model="erplinkid" placeholder="请输入企业内码" style="margin: 10px 0 5px; width: 100%" />
            <vxe-input v-model="erplinkname" placeholder="请输入企业名称" style="margin: 5px 0; width: 100%" />
            <vxe-button status="primary" :style="
                'margin:5px 0;width:100%;background-color:' +
                ssbgcolor1 +
                ';border-color:' +
                ssbgcolor1
              " @click="erpcomClick('2')" content="申请加入该企业"></vxe-button>
            <vxe-button status="primary" :style="
                'margin:5px 0;width:100%;background-color:' +
                ssbgcolor1 +
                ';border-color:' +
                ssbgcolor1
              " @click="erpcomClick('3')" content="同意加入该企业"></vxe-button>
            <vxe-button content="拒绝加入该企业" style="margin: 5px 0; width: 100%" @click="erpcomClick('4')"></vxe-button>
            <vxe-button content="撤销该企业申请" style="margin: 5px 0; width: 100%" @click="erpcomClick('1')"></vxe-button>
          </div>
          <div style="position: relative; max-height: 250px; overflow-y: auto; width: 100%">
            <div style="
                height: 30px;
                font-weight: 600;
                position: absolute;
                left: 10px;
                top: 0;
              ">
              待处理企业：
            </div>
            <div style="height: 30px"></div>
            <div style="
                display: flex;
                flex-wrap: wrap;
                line-height: 30px;
                height: 30px;
                overflow-y: auto;
              ">
              <div style="margin: 0 10px" v-for="(item, index) in erpComlist" @click="erpcomClick('5', item)"
                :key="index">
                {{ item.fname }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showname" width="330" height="100" title="昵称修改">
      <div class="models">
        <div class="model-b">
          <vxe-input v-model="fnickname" size="mini" placeholder="请输入昵称" clearable />
          <div>
            <vxe-button status="info" content="取消" size="mini" @click="cancelName"></vxe-button>
            <vxe-button size="mini"
              :style="'background-color:' + ssbgcolor + ';border-color:' + ssbgcolor + ';color: #fff;'"
              @click="comfirmName" content="确认"></vxe-button>
          </div>
        </div>
      </div>
    </vxe-modal>
    <!-- 修改密码 -->
    <vxe-modal v-model="editPWDmodal" title="修改密码" width="350" :mack="false">
      <div class="pwdboxs">
        <div class="boxTpo">
          <div class="boxTpo_item">
            <div class="boxTpo_item_left">旧密码:</div>
            <div class="boxTpo_item_right">
              <vxe-input v-model="oldPWD" type="password" style="width: 95%" placeholder="请输入旧的密码"
                clearable></vxe-input>
            </div>
          </div>
          <div class="boxTpo_item">
            <div class="boxTpo_item_left">新密码:</div>
            <div class="boxTpo_item_right">
              <vxe-input v-model="newPWD" type="password" style="width: 95%" placeholder="请输入新的密码"
                clearable></vxe-input>
            </div>
          </div>
        </div>
        <div class="boxTtn">
          <vxe-button status="info" style="width: 25%" size="mini" content="取消" @click="
              editPWDmodal = false;
              newPWD = '';
              oldPWD = '';
            "></vxe-button>
          <vxe-button status="danger" style="width: 25%" size="mini" content="设置" @click="editPWD"></vxe-button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
  import TopMode from "../components/topMode";
  import TopUser from "../components/topuser";
  import History from "../components/History";
  import axios from "axios";
  import router from "@/router/index.js";
  import ObsClient from "../../dist/esdk-obs-browserjs-without-polyfill-3.19.5.min.js";
  import { version, viewVersion } from "../index.js";
  var obsClient;
  export default {
    components: {
      History,
      TopMode,
      TopUser,
    },
    data() {
      return {
        viewVersion: viewVersion,
        bblist: [],
        mainloading: false,
        editPWDmodal: false,
        newPWD: "",
        oldPWD: "",
        userListhave: [],
        userListtoadd: [],
        userListtodel: [],
        userListAll: [],
        xtpzcode: "",
        hasKcm: false,
        showxtpz: false,
        erpComObj: {},
        erpComlist: [],
        showkcmCom: false,
        kcmComObj: {
          fuserid: -1,
          fusername: "",
          fworkerid: -1,
          fworkername: "",
          fcsid: -1,
          fcsname: "",
        },
        iskcmUser: false,
        showerpCom: false,
        erplinkid: "",
        erplinkname: "",
        isAsadmin: false,
        fnickname: "",
        showcolor: false,
        showname: false,
        ssbgcolor: this.$Store.state.bgcolor,
        ssbgcolor1: this.$Store.state.bgcolor,
        loginTime: "",
        company: {},
        userinfo: {},
        userImg: "",
        historyIndex: -1,
        historyList: [],
        mainWidth: window.innerWidth - 150,
        screenHeight: window.innerHeight,
        isshow: true,
        toolList: this.$Datalist.toolList,
        systemName: "进销存管理系统",
        toplist: this.$Datalist.list, // 导航数据
        sort_books: [], // 侧边导航数据
        asideShow: false, // 关闭侧边栏
        topSelectArray: ["主页"], // top 选中头部导航数据
        leftSelectArray: [], // left 选中侧边导航数据
        count: 0,
        tabLists: [], // 路由栈
        tabSelect: {}, // 选中路由栈
        screenWidth: window.innerWidth,
        agtkcmapi: "https://app.ncerp.cn:29601/api/kcm/",
        specialNaviid: [],
        newarr: [],
        array: [],
        flinkid: -1,
        gocid: -1,
      };
    },
    computed: {},
    created() {
      this.flinkid = JSON.parse(localStorage.getItem('agtuserinfo')).flinkid;
      this.gocid = JSON.parse(localStorage.getItem("agtuserinfo")).fgocid ?
        JSON.parse(localStorage.getItem("agtuserinfo")).fgocid :
        JSON.parse(localStorage.getItem("agtuserinfo")).fcorp.gocid;
      if (localStorage.getItem("agtkcmapi")) {
        this.agtkcmapi = localStorage.getItem("agtkcmapi");
      }
      this.loginTime = localStorage.getItem("agtlogintime");
      this.$axios.defaults.headers["token"] = localStorage.getItem("agttoken");
      if (sessionStorage.getItem("historyList")) {
        this.historyList = JSON.parse(sessionStorage.getItem("historyList"));
        this.historyIndex = sessionStorage.getItem("historyIndex");
        this.log(this.historyList, this.historyIndex);
        if (this.historyList[this.historyIndex]) {
          let id = this.historyList[this.historyIndex].fnaviid;
          this.$Store.dispatch("onchangSetnaviid", id);
          this.$Store.dispatch(
            "onchangSetnaviName",
            this.historyList[this.historyIndex].name
          );
        }
      }

      this.getCompany();
      this.getauth();
      this.findUser();
      this.getNaviList();
      this.userinfo = JSON.parse(localStorage.getItem("agtuserinfo"));
      window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
      if (!this.isAsadmin) {
        this.toolList.forEach((tool) => {
          if (tool.name == "设置") {
            tool.children[0].list.forEach((item, index) => {
              if (item.name == "系统配置" || item.name == "报表设计") {
                tool.children[0].list.splice(index, 1);
              }
            });
          }
        });
      }
    },
    destroyed() {
      // 组件销毁后解绑事件
      window.onresize = null;
    },
    mounted() {
      this.mainWidth = window.innerWidth - 150;
      this.screenHeight = window.innerHeight;
      this.screenWidth = window.innerWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = window.innerWidth;
          this.mainWidth = window.innerWidth - 150;
          this.$Store.dispatch("onchangLeftWidth", 150);
          this.$Store.dispatch("onchanghtmlWidth", window.innerWidth);
          this.$Store.dispatch("onchanghtmlHeight", window.innerHeight);
          if (!this.isshow) {
            this.mainWidth = window.innerWidth - 50;
            this.$Store.dispatch("onchangLeftWidth", 50);
          }
          this.screenHeight = window.innerHeight;
        })();
      };
      if (localStorage.getItem("agtsscolor")) {
        this.$Store.dispatch("onchangColor", localStorage.getItem("agtsscolor"));
      }
      obsClient = new ObsClient({
        access_key_id: "QTEZALFEWXYLBIPF1ZXH",
        secret_access_key: "hgh3XEUxF0bqt2Klu9DNbnG9goAdj2HqoHFL8RfK",
        server: "https://obs.cn-south-1.myhuaweicloud.com",
      });
      // 监听鼠标
      document.onmousemove = (event) => {
        let x1 = event.clientX;
        let y1 = event.clientY;
        if (this.x !== x1 || this.y !== y1) {
          this.count = 0;
        }
        this.x = x1;
        this.y = y1;
      };
      // 监听键盘
      document.onkeydown = () => {
        this.count = 0;
      };

      // 监听Scroll
      document.onscroll = () => {
        this.count = 0;
      };
      window.onbeforeunload = (e) => {
        this.log("onbeforeunload", this.$route.path.split("/")[2]); //刷新时弹出提示
        sessionStorage.setItem("routerhistory", this.$route.path.split("/")[2]);
        if (this.$refs.rout) {
          let rout = this.$refs.rout.$refs.page;
          if (rout) {
            sessionStorage.setItem("topname", rout.topName);
          }
        }
      };
      this.listenPage();
    },
    methods: {
      // 获取导航配置
      getNaviList() {
        const objs = {
          system: "agt",
          visit: "web",
          linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          gocid: this.gocid,
          version: version
        };
        this.specialNaviid = [];
        this.array = [];
        this.newarr = [];
        axios.post("user/uinavi/find", objs).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data) {
              this.toolList = JSON.parse(JSON.stringify(res.data.data));
              for (let i = 0; i < this.toolList.length; i++) {
                const item = this.toolList[i];
                for (let j = 0; j < item.children.length; j++) {
                  const item2 = item.children[j];
                  for (let k = 0; k < item2.list.length; k++) {
                    const item3 = item2.list[k];
                    // 将导航节点中带有 fnavino 字段的naviid缓存起来
                    if (item3.fnavino && item3.fnavino != "") {
                      let id = item3.fnaviid == "cpzl1" ? 4111 : Number(String(item3.fnaviid));
                      this.specialNaviid.push(id);
                    }
                    this.array.push(String(item3.fnaviid));
                    this.newarr.push({
                      fname: item3.fname,
                      fname1: item3.fname1,
                      fnaviid: item3.fnaviid,
                      fnavino: item3.fnavino ? item3.fnavino : "",
                    });
                  }
                }
              }
              this.$Datalist.toolList = this.toolList;
              localStorage.setItem("specialNaviid",JSON.stringify(this.specialNaviid));
            } else {
              this.toolList = this.$Datalist.toolList;
              localStorage.setItem("specialNaviid", this.specialNaviid);
            }
          } else {
            this.toolList = this.$Datalist.toolList;
            localStorage.setItem("specialNaviid", this.specialNaviid);
          }
        });
      },
      // 修改密码
      editPWD() {
        if (!this.newPWD) {
          this.$alert("请输入密码!", "错误提示", {confirmButtonText: '确定', type: "error"});
          return;
        }
        this.mainloading = true;
        this.editPWDmodal = false;
        axios.post("user/pass/save", {
          system: "agt",
          visit: "web",
          douserid: Number(JSON.parse(localStorage.getItem("agtuserinfo")).fuserid),
          domobile: Number(JSON.parse(localStorage.getItem("agtuserinfo")).fmobile),
          captcha: "",
          userpass: this.oldPWD,
          newpass: this.newPWD,
          linkid: JSON.parse(localStorage.getItem("agtcominfo")).flinkid,
          gocid: this.gocid,
          version: version
        }).then((res) => {
          this.mainloading = false;
          if (res.data.code == 0) {
            this.$message.success("修改密码成功,请重新登录!");
            this.newPWD = "";
            // 退出重新登录
            const agtmainapi = JSON.parse(
              JSON.stringify(localStorage.getItem("agtmainapi"))
            );
            const agtkcmapi = JSON.parse(JSON.stringify(localStorage.getItem("agtkcmapi")));
            let agtpwdCheckState = false,
              agtuserPwd = "",
              agtuserPhone = "";
            if (localStorage.getItem("agtpwdCheckState")) {
              agtpwdCheckState = JSON.parse(
                JSON.stringify(localStorage.getItem("agtpwdCheckState"))
              );
              agtuserPwd = JSON.parse(JSON.stringify(localStorage.getItem("agtuserPwd")));
              agtuserPhone = JSON.parse(
                JSON.stringify(localStorage.getItem("agtuserPhone"))
              );
            }
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem("agtmainapi", agtmainapi);
            localStorage.setItem("agtkcmapi", agtkcmapi);
            localStorage.setItem("agtpwdCheckState", agtpwdCheckState);
            localStorage.setItem("agtuserPwd", agtuserPwd);
            localStorage.setItem("agtuserPhone", agtuserPhone);
            this.$router.replace("/");
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      savekcmUser() {
        let arr = [];
        let arr1 = [];
        this.userListtoadd.forEach((el) => {
          let obj = {
            fuserid: Number(el.fmobile),
            fusername: el.fnickname,
            fauth: [],
            fmore: {},
          };
          arr.push(obj);
        });
        this.userListtodel.forEach((el) => {
          arr1.push(el.fuserid);
        });
        let data = {
          visit: "web",
          system: "kcm",
          agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          data: arr,
        };
        let data1 = {
          visit: "web",
          system: "kcm",
          agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          data: arr1,
        };
        this.$axios.post(this.agtkcmapi + "agent/user/add", data).then((res) => {
          if (res.data.code == "0") {
            this.$message.success("添加成功");
            if (JSON.stringify(arr1) != "[]") {
              this.$axios.post(this.agtkcmapi + "agent/user/del", data1).then((ress) => {
                if (ress.data.code == "0") {
                  this.$message.success("删除成功");
                  this.getKcmobj();
                  this.iskcmUser = false;
                  this.userListtoadd = [];
                  this.userListtodel = [];
                } else {
                  this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
                }
              });
            } else {
              this.iskcmUser = false;
              this.getKcmobj();
              this.userListtoadd = [];
            }
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      closekcmUser() {
        this.iskcmUser = false;
        this.userListtoadd = [];
        this.userListtodel = [];
      },
      addListOne(item) {
        this.userListtoadd.push(item);
      },
      delListOne(item) {
        this.userListtodel.push(item);
      },
      deldeltOne(index) {
        this.userListtodel.splice(index, 1);
      },
      deladdtOne(index) {
        this.userListtoadd.splice(index, 1);
      },
      findUser() {
        axios.post("user/list/find", {
          system: "agt",
          visit: "web",
          linkid: this.flinkid,
          gocid: this.gocid,
          version: version
        }).then((res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            this.userListAll = res.data.data;
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      showkcmUser() {
        this.iskcmUser = true;
      },
      comfirmKcm2() {
        //解除
        this.$confirm("确定解除关系吗").then(() => {
          this.$axios.post(this.agtkcmapi + "agent/bind/del", {
              visit: "web",
              system: "kcm",
              agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
            }).then((res) => {
              if (res.data.code == "0") {
                this.$alert("解除成功", "错误提示", {confirmButtonText: '确定', type: "error"});
                this.kcmComObj = {};
                this.showkcmCom = false;
                this.hasKcm = false;
              } else {
                this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
              }
            });
        });
      },
      comfirmKcm() {
        let data = {
          visit: "web",
          system: "kcm",
          agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          data: {
            fuserid: -1,
            fusername: this.kcmComObj.fusername,
            fworkerid: -1,
            fworkername: this.kcmComObj.fworkername,
            fcsid: -1,
            fcsname: this.kcmComObj.fcsname,
          },
        };
        this.$axios.post(this.agtkcmapi + "agent/bind/set", data).then((res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            this.$message.success("绑定成功");
            this.cancelKcm();
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      cancelKcm() {
        this.showkcmCom = false;
        this.kcmComObj = {
          fuserid: -1,
          fusername: "",
          fworkerid: -1,
          fworkername: "",
          fcsid: -1,
          fcsname: "",
        };
      },
      toBG(e) {
        // if (e == "办公") {
        //   let isFirst = false;
        //   let index1 = -1;
        //   this.historyList.forEach((el, index) => {
        //     if (el.name == "轻办公") {
        //       isFirst = true;
        //       index1 = index;
        //     }
        //   });
        //   if (!isFirst) {
        //     this.historyList.push({
        //       name: "轻办公",
        //       code: "yhbg",
        //       fnaviid: 9271,
        //     });
        //     this.historyIndex = this.historyList.length - 1;
        //   } else {
        //     this.historyIndex = index1;
        //   }
        //   // this.$Store.dispatch('onchangSetnaviid','9271')
        //   // this.$Store.dispatch('onchangSetnaviName','系统配置')
        //   this.$Store.dispatch("onchangIsfirst", false);
        //   this.$router.push("/home/yhbg");
        // }
      },
      comfirmxtpz() {
        if (this.xtpzcode == "修改系统配置") {
          this.showxtpz = false;
          this.historyList.push({
            name: "模块配置",
            code: "xtpz",
            fnaviid: 9115,
          });
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", "9115");
          this.$Store.dispatch("onchangSetnaviName", "模块配置");
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/xtpz");
        } else {
          this.message.error("密码错误，请重新输入");
        }
      },
      cancelxtpz() {
        this.showxtpz = false;
      },
      geterpList() {
        let data = {
          visit: "web",
          system: "agt",
          gocid: this.gocid,
          version: version,
          linkid: this.flinkid
        };
        this.$axios.post("boss/linktoerp/data", data).then((res) => {
          if (res.data.code == 0) {
            this.log(res.data.data);
            if (res.data.data) {
              if (res.data.data.fstatus == "accepted") {
                this.erpComObj = res.data.data;
              } else if (res.data.data.fstatus == "waiting") {
                this.erpComlist.push(res.data.data);
              }
            }
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      erpcomClick(e, item) {
        if (e == "1") {
          let data = {
            visit: "web",
            system: "agt",
            gocid: this.gocid,
            version: version,
            linkid: this.flinkid
          };
          this.$axios.post("boss/linktoerp/remove", data).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("已解除当前挂靠企业");
              this.erpComObj = {};
              this.erplinkname = "";
              this.erplinkid = "";
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          });
        } else if (e == "2") {
          let data = {
            visit: "web",
            system: "agt",
            erplinkid: -1,
            erplinkname: this.erplinkname,
          };
          if (this.erplinkid) {
            data.erplinkid = Number(this.erplinkid);
          }
          this.$axios.post("boss/linktoerp/create", data).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("申请成功，等待处理");
              this.erplinkname = "";
              this.erplinkid = "";
              this.showerpCom = false;
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          });
        } else if (e == "3") {
          let data = {
            visit: "web",
            system: "agt",
            erplinkid: Number(this.erplinkid),
            status: "accepted",
            version: version
          };
          this.$axios.post("boss/linktoerp/confirm", data).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("操作成功");
              this.erpComObj.fname = this.erplinkname;
              this.erplinkname = "";
              this.erplinkid = "";
              this.showerpCom = false;
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          });
        } else if (e == "4") {
          let data = {
            visit: "web",
            system: "agt",
            gocid: this.gocid,
            version: version,
            linkid: this.flinkid
          };
          this.$axios.post("boss/linktoerp/remove", data).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("已拒绝该企业申请");
              this.erpComlist = [];
              this.erplinkname = "";
              this.erplinkid = "";
            } else {
              this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          });
        } else if (e == "5") {
          this.erplinkname = item.fname;
          this.erplinkid = item.flinkid;
        }
      },
      getauth() {
        if (localStorage.getItem("agtuserinfo")) {
          if (JSON.parse(localStorage.getItem("agtuserinfo")).fconfig) {
            if (JSON.parse(localStorage.getItem("agtuserinfo")).fconfig.auth) {
              if (JSON.parse(localStorage.getItem("agtuserinfo")).fconfig.auth.agt) {
                this.isAsadmin = JSON.parse(
                  localStorage.getItem("agtuserinfo")
                ).fconfig.auth.agt.asadmin;
              }
            }
          }
        }
      },
      onUploadChange(file) {
        this.uploadPic(file.raw, file.name);
      },
      uploadPic(e, e1) {
        let data = {
          system: "agt",
          visit: "web",
          userid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
          linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          naviid: -1,
          lockuser: true,
          gocid: this.gocid,
          version: version,
        };
        this.$axios.post("obs/create", data).then((res) => {
          if (res.data.code == 0) {
            this.log(res.data.data);
            this.setObs(res.data.data, e, e1);
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      setObs(data, file, name) {
        //上传文件，带类型
        this.log("file", file);
        this.log("file", name);
        let arrr = name.split(".");
        let type = name.split(".")[arrr.length - 1];
        let str = `${data.path}${data.file}.${type}`;
        this.log(str);
        obsClient.putObject({
            Bucket: data.bucket,
            Key: str,
            SourceFile: file,
            PartSize: 9 * 1024 * 1024,
            TaskNum: 3,
            ContentType: file.type,
            ACL: obsClient.enums.AclPublicRead,
            ProgressCallback: function(transferredAmount, totalAmount) {},
            EventCallback: function(eventType, eventParam, eventResult) {},
            ResumeCallback: function(resumeHook, uploadCheckpoint) {},
          },
          // 成功、失败回调函数
          (err, result) => {
            if (err) {
              this.$message.error("err", err);
            } else {
              this.log("success", result);
              this.retObs(data, name, type, file.size);
            }
          }
        );
      },
      retObs(e, e1, e2, e3) {
        let data = {
          system: "agt",
          visit: "web",
          lockto: "user",
          keyword: "head",
          douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
          gocid: this.gocid,
          version: version,
          linkid: this.flinkid,
          naviid: -1,
          billid: -1,
          dataid: -1,
          data: [{
            bucket: e.bucket,
            path: e.path,
            file: e.file,
            type: `.${e2}`,
            size: e3,
            title: e1,
          }, ],
        };
        this.$axios.post("obs/upload", data).then((res) => {
          if (res.data.code == 0) {
            this.delImg();
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
        this.log(data);
      },
      delImg() {
        let arr = [];
        if (JSON.parse(localStorage.getItem("agtuserinfo")).ffile) {
          JSON.parse(localStorage.getItem("agtuserinfo")).ffile.forEach((el) => {
            if (el.keyword == "head") {
              el.data.forEach((ell) => {
                let item = {
                  bucket: ell.bucket,
                  path: ell.path,
                  file: ell.file,
                  type: ell.type,
                };
                arr.push(item);
              });
            }
          });
          let data = {
            system: "agt",
            visit: "web",
            lockto: "user",
            douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
            gocid: this.gocid,
            version: version,
            linkid: this.flinkid,
            keyword: "head",
            naviid: -1,
            billid: -1,
            dataid: -1,
            bucket: "ncktc",
            data: arr,
          };
          this.$axios.post("obs/delete", data)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success("修改成功，请重新登录");
                setTimeout(() => {
                  const agtmainapi = JSON.parse(
                    JSON.stringify(localStorage.getItem("agtmainapi"))
                  );
                  const agtkcmapi = JSON.parse(
                    JSON.stringify(localStorage.getItem("agtkcmapi"))
                  );
                  localStorage.clear();
                  localStorage.setItem("agtmainapi", agtmainapi);
                  localStorage.setItem("agtkcmapi", agtkcmapi);
                  this.$router.replace("/");
                }, 1500);
              } else {
                this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
              }
            })
            .catch((e) => {
              this.log(JSON.stringify(e));
            });
        }
      },
      comfirmColor() {
        this.$Store.dispatch("onchangColor", this.ssbgcolor1);
        localStorage.setItem("agtsscolor", this.ssbgcolor1);
        this.ssbgcolor = this.ssbgcolor1;
        if (this.$refs.rout) {
          if (this.$refs.rout.ssbgcolor) {
            this.$refs.rout.ssbgcolorr = this.ssbgcolor1;
          }
        }
        if (this.$refs.rout1) {
          if (this.$refs.rout1.ssbgcolor) {
            this.$refs.rout1.ssbgcolorr = this.ssbgcolor1;
          }
        }

        this.showcolor = false;
        this.$message.success("更改成功，请刷新网页");
      },
      cancelColor() {
        this.ssbgcolor1 = this.ssbgcolor;
        this.showcolor = false;
      },
      cancelName() {
        this.fnickname = "";
        this.showname = false;
      },
      comfirmName() {
        let data = {
          system: "agt",
          visit: "web",
          douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
          domobile: JSON.parse(localStorage.getItem("agtuserinfo")).fmobile,
          data: {
            nickname: this.fnickname,
          },
          gocid: this.gocid,
          version: version,
          linkid: this.flinkid
        };
        this.$axios.post("user/nickname/save", data).then((res) => {
          if (res.data.code == 0) {
            this.fnickname = "";
            this.showname = false;
            this.$message.success("修改成功,请重新登录");
            setTimeout(() => {
              const agtmainapi = JSON.parse(
                JSON.stringify(localStorage.getItem("agtmainapi"))
              );
              const agtkcmapi = JSON.parse(
                JSON.stringify(localStorage.getItem("agtkcmapi"))
              );
              localStorage.clear();
              localStorage.setItem("agtmainapi", agtmainapi);
              localStorage.setItem("agtkcmapi", agtkcmapi);
              this.$router.replace("/");
            }, 1500);
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      beforeunloadFn(e) {
        sessionStorage.setItem("historyList", JSON.stringify(this.historyList));
        sessionStorage.setItem("historyIndex", this.historyIndex);
      },
      toAddzl(e) {
        this.log("182home", e, this.historyList);
        let id = e;
        let code = "";
        let name = "";
        if (e == 4132) {
          code = "gfzl";
          name = "供方资料";
        } else if (e == 4131) {
          code = "khzl";
          name = "客户资料";
        } else if (e == 4111) {
          code = "spzl";
          name = "商品资料";
        } else if (e == 4113) {
          code = "bmyg";
          name = "部门员工";
        }
        if (e == 4132 || e == 4111 || e == 4131 || e == 4113) {
          this.$Store.dispatch("onchangSetnaviid", id);
          this.$Store.dispatch("onchangSetnaviName", name);
          this.$router.push("/home/" + code);
          let isHave = false;
          this.historyList.forEach((el, index) => {
            if (el.code == code) {
              isHave = true;
              this.historyIndex = index;
            }
          });
          if (!isHave) {
            let obj = {
              code: code,
              fnaviid: id,
              name: name,
            };
            this.historyList.push(obj);
            this.historyIndex = this.historyList.length - 1;
          }
        }
      },
      useoftenTo(e) {
        this.log("home", e);
        this.toPage(e);
      },
      useoftenTo2(e) {
        this.log(e);
        this.toPage2(e);
      },
      handleCommand(e) {
        if (e == "closeAll") {
          this.closeAll();
        } else {
          this.closeNow();
        }
      },
      getKcmobj() {
        this.$axios.post(this.agtkcmapi + "agent/find", {
          visit: "web",
          system: "kcm",
          agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        }).then((res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            if (JSON.stringify(res.data.data) != "{}") {
              this.kcmComObj = res.data.data.fdata;
              this.userListhave = res.data.data.fuser;
              this.hasKcm = true;
              this.showkcmCom = true;
            } else {
              this.hasKcm = false;
              this.kcmComObj = {
                fuserid: -1,
                fusername: "",
                fworkerid: -1,
                fworkername: "",
                fcsid: -1,
                fcsname: "",
              };
              this.showkcmCom = true;
            }
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      handleCommand1(e) {
        if (e == "changeColor") {
          this.showcolor = true;
        } else if (e == "changename") {
          this.showname = true;
        } else if (e == "bossQuit") {
          this.$confirm("确定要退出公司团队吗").then(() => {
            let data = {
              visit: "web",
              system: "agt", //可传erp,agt,ncx,ncv,nco,nshop,kjxc,kfin,kcode,kbiz,koa
              domobile: JSON.parse(localStorage.getItem("agtuserinfo")).fmobile, //加入人的手机号
              douserid: -1, //申请人的用户内码，如果传了手机号，这里传-1即可
              gocid: this.gocid,
              version: version,
              linkid: this.flinkid
            };
            this.$axios.post("boss/quit", data).then((res) => {
              if (res.data.code == 0) {
                this.$message.success("退出成功,请加入团队");
                setTimeout(() => {
                  const agtmainapi = JSON.parse(
                    JSON.stringify(localStorage.getItem("agtmainapi"))
                  );
                  const agtkcmapi = JSON.parse(
                    JSON.stringify(localStorage.getItem("agtkcmapi"))
                  );
                  localStorage.clear();
                  localStorage.setItem("agtmainapi", agtmainapi);
                  localStorage.setItem("agtkcmapi", agtkcmapi);
                  this.$router.replace("/");
                }, 1500);
              } else {
                this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
              }
            });
          });
        } else if (e == "erpCom") {
          if (this.isAsadmin) {
            this.showerpCom = true;
            this.erpComObj = {};
            this.erplinkname = "";
            this.erplinkid = "";
            this.erpComlist = [];
            this.geterpList();
          } else {
            this.$alert("当前账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e == "kcmCom") {
          if (this.isAsadmin) {
            this.getKcmobj();
          } else {
            this.$alert("当前账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e == "changePwd") {
          this.editPWDmodal = true;
        }
      },
      getCompany() {
        let bossinfo = JSON.parse(localStorage.getItem("agtuserinfo")).fconfig;
        this.company = bossinfo.link.agt;
        localStorage.setItem("agtcominfo", JSON.stringify(this.company));
        setTimeout(() => {
          if (localStorage.getItem("agtuserImg")) {
            this.userImg = localStorage.getItem("agtuserImg");
          }
        }, 1500);
      },
      loginOut() {
        this.$XModal.modal.confirm("真的要退出系统吗？").then((type) => {
          if(type == "confirm"){
            this.historyList = [];
            this.historyIndex = -1;
            const agtmainapi = JSON.parse(JSON.stringify(localStorage.getItem("agtmainapi")));
            const agtkcmapi = JSON.parse(JSON.stringify(localStorage.getItem("agtkcmapi")));
            let agtpwdCheckState = null, userPhone = null, userPwd = null;
            if (localStorage.hasOwnProperty('agtpwdCheckState') && localStorage.getItem('agtpwdCheckState') == 'true') {
              agtpwdCheckState = true;
              if (localStorage.hasOwnProperty("agtuserPhone")) {
                userPhone = localStorage.getItem("agtuserPhone");
              }
              if (localStorage.hasOwnProperty('agtuserPwd')) {
                userPwd = localStorage.getItem("agtuserPwd");
              }
            }
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem("agtmainapi", agtmainapi);
            localStorage.setItem("agtkcmapi", agtkcmapi);
            if(agtpwdCheckState){
              localStorage.setItem('agtpwdCheckState', agtpwdCheckState);
              localStorage.setItem("agtuserPhone", userPhone);
              localStorage.setItem("agtuserPwd", userPwd);
            }
            this.$router.replace("/");
          }
        });
      },

      // 关闭全部导航模块
      closeAll() {
        this.historyList = [];
        this.historyIndex = -1;
        this.$router.replace("/home");
      },

      // 关闭当前导航模块
      closeNow() {
        this.historyList.splice(this.historyIndex, 1);
        this.historyIndex = -1;
        this.$router.replace("/home");
      },
      closeOne(e, index) {
        if (index != this.historyIndex) {
          this.log("if");
          this.historyList.splice(index, 1);
          this.historyIndex--;
        } else {
          this.historyList.splice(index, 1);
          this.historyIndex = -1;
          this.log("else");
          this.$router.replace("/home");
        }
        // this.historyIndex=index-1
      },
      toHome() {
        this.log("tohome");
        this.$router.push({
          path: "/home"
        });
        this.historyIndex = -1;
      },
      toauthpage(e) {
        console.log(e);
        this.mainloading = true;
        if (
          e.code == "xtcsh" ||
          e.code == "sjwh" ||
          e.code == "rzzx" ||
          e.code == "xtsz" ||
          e.code == "sqzx" ||
          e.code == "xtglsjpz "
        ) {
          if (this.isAsadmin || this.userinfo.fmobile == "13609283094") {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.mainloading = false;
            this.$router.push("/home/" + e.code);
          } else {
            this.mainloading = false;
            this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e.code == "xtsz") {
          if (localStorage.getItem("agtcompany") == "undefined" || this.isAsadmin) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.mainloading = false;
            this.$router.push("/home/" + e.code);
          } else {
            this.mainloading = false;
            this.$alert("该账号暂无改操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e.code == "9272") {
          if (
            this.userinfo.fmobile == "13609283094" ||
            this.userinfo.fmobile == "13332993762" ||
            this.userinfo.fmobile == "13332901386" ||
            this.userinfo.fmobile == "22000000005" ||
            this.userinfo.fmobile == "22000000004" ||
            this.userinfo.fmobile == "22000000003" ||
            this.userinfo.fmobile == "22000000002" ||
            this.userinfo.fmobile == "22000000001" ||
            this.userinfo.fmobile == "22000000120"
          ) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.mainloading = false;
            this.$router.push("/home/" + e.code);
          } else {
            this.mainloading = false;
            this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e.code == "xtpz") {
          // this.showxtpz = true;
          if (this.isAsadmin) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.mainloading = false;
            this.$router.push("/home/" + e.code);
          } else {
            this.mainloading = false;
            this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        } else if (e.code == "bzzx") {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.mainloading = false;
          this.$router.push("/home/" + e.code);
        } else if(e.fnaviid == 9271){ //报表
          console.log("进入报表");
          // 判断是否有权限
          if (this.isAsadmin) {
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.gotoReport(e);
          }else{
            const objs = {
              naviid: 9271,
              dataid: e.fdataid,
              system: "agt",
              visit: "web",
              linkid: this.flinkid,
              gocid: this.gocid,
              version: version
            };
            axios.post("info/data", objs).then(res=>{
              if(res.data.code === 0){
                if(res.data.data && res.data.data.length > 0){
                  const userlist = res.data.data[0].fdata && res.data.data[0].fdata.user && res.data.data[0].fdata.user.length > 0 ? res.data.data[0].fdata.user : [];
                  if(userlist.length == 0){
                    this.mainloading = false;
                    this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
                    return;
                  }
                  const index = userlist.findIndex(item=>item.userid == this.userinfo.fuserid);
                  if(index == -1){
                    this.mainloading = false;
                    this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
                    return;
                  }
                  this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
                  this.$Store.dispatch("onchangSetnaviName", e.name);
                  this.$Store.dispatch("onchangIsfirst", false);
                  this.gotoReport(e);
                }else{
                  this.mainloading = false;
                  this.$alert("该账号暂无该操作权限", "错误提示", {confirmButtonText: '确定', type: "error"});
                }
              }else{
                this.mainloading = false;
                this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
              }
            });
          }
        }else {
          if (this.isAsadmin) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.mainloading = false;
            this.$router.push("/home/" + e.code);
          } else {
            this.mainloading = false;
            this.getAuthID(e);
          }
          this.log(e.code, e.fnaviid);
        }
      },
      gotoReport(e){
        let isHave = false;
        this.historyList.forEach((el, index) => {
          if (el.fnaviid == e.fnaviid) {
            isHave = true;
            this.historyIndex = index;
          }
        });
        
        setTimeout(() => {
          if (this.$refs.rout && this.$refs.rout.isGetDataUi) {
            const historyBB = this.$Store.state.historyBB;
            const bbinfo = historyBB.find((bb) => bb.fdataid == e.fdataid);
            console.log("bbinfo", bbinfo);
            if (bbinfo) {
              this.$refs.rout.tableData = bbinfo.tableData;
              this.$refs.rout.copyTabData = bbinfo.tableData;
            } else {
              this.$refs.rout.tableData = [];
              this.$refs.rout.copyTabData = [];
            }
            this.$refs.rout.row = {
              ...e,
              fname: bbinfo ? (bbinfo.fname2 || bbinfo.fname) : e.fname,
            };
            this.$refs.rout.groupid = e.fgroupid;
            this.$refs.rout.showMenu = false;
            this.$refs.rout.dataid = e.fdataid;
            this.$refs.rout.mainwidth = this.$refs.rout.screenWidth - 150;
            this.$refs.rout.tableDatatk = [];
            this.$refs.rout.cellclasstk = [];
            this.$refs.rout.tableColumntk = [];
            this.$refs.rout.mergeCells = [];
            this.$nextTick(() => {
              this.$refs.rout.getTableDataUI();
            });
            this.$refs.rout.showmodelgl = true;
            this.$refs.rout.shuaxintk();
            this.$refs.rout.getData(); //获取资料分组

            this.$refs.rout.showcsname = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.showcsname
              : "";
            this.$refs.rout.showstock = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.showstock
              : "";
            this.$refs.rout.begdate = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.begdate
              : "";
            this.$refs.rout.enddate = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.enddate
              : "";
            this.$refs.rout.showdept = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.showdept
              : "";
            this.$refs.rout.countamountlist = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.countamountlist
              : [];
            this.$refs.rout.dataconfig = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.dataconfig
              : {};
            this.$refs.rout.pageconfig.total = bbinfo && bbinfo.infoObj
              ? bbinfo.infoObj.pageconfig.total
              : 0;
            this.$refs.rout.showLsbbMore = false;
          }
        }, 500);

        // 将点过的报表记录起来
        this.bblist = [...this.$Store.state.historyBB, ...this.bblist];
        let obj = {};
        this.bblist = this.bblist.reduce((cur, next) => {
          obj[next.fdataid] ? "" : (obj[next.fdataid] = true && cur.push(next));
          return cur;
        }, []);
        const isBb = this.bblist.find((x) => x.fdataid == e.fdataid);
        if (!isBb) {
          this.bblist.push({
            fdata: e.fdata,
            fdataid: e.fdataid,
            fgroupid: e.fgroupid,
            fname: e.fname,
            fnaviid: e.fnaviid,
          });
        }
        this.historyList.forEach((el, index) => {
          if (el.fnaviid == e.fnaviid) {
            el.code = e.code;
            el.fname = e.fname;
            el.name = e.name;
            el.fdata = e.fdata;
            el.fdataid = e.fdataid;
            el.fgroupid = e.fgroupid;
          }
        });
        this.$Store.dispatch("onchangSethistoryBB", this.bblist);
        console.log("isHave", isHave);
        if (!isHave) {
          this.getReportauth(e);
          return;
        }
        this.mainloading = false;
        this.$router.push("/home/" + e.fnaviid);
      },
      getReportauth(e){
        this.mainloading = false;
        console.log("getReportauth", e);
        this.$Store.dispatch("onchangSetnaviid", String(e.fnaviid));
        this.$Store.dispatch("onchangSetnaviName", e.name);
        this.$router.push({
          path: "/home/" + e.fnaviid
        });
        this.historyList.push(e);
        this.historyIndex = this.historyList.length - 1;
        sessionStorage.setItem("historyIndex", JSON.stringify(this.historyIndex));
        sessionStorage.setItem("historyList", JSON.stringify(this.historyList));
      },
      getAuthID(e) {
        this.log(e,'4565645465465465564564')
        let userid = JSON.parse(localStorage.getItem("agtuserinfo")).fuserid;
        let usertel = JSON.parse(localStorage.getItem("agtuserinfo")).fmobile;
        let data = {
          system: "agt",
          naviid: e.fnaviid,
          douserid: userid,
          domobile: usertel,
          gocid: this.gocid,
          version: version,
          linkid: this.flinkid
        };
        this.mainloading = false;
        this.$axios.post("user/auth/info", data).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.asadmin || res.data.data.view) {
              this.historyList.push(e);
              this.historyIndex = this.historyList.length - 1;
              this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
              this.$Store.dispatch("onchangSetnaviName", e.name);
              this.$Store.dispatch("onchangIsfirst", false);
              this.$router.push("/home/" + e.code);
            } else if (res.data.config.asadmin || res.data.config.view||e.fname=="总部库存"||e.name=="总部库存") {
              this.historyList.push(e);
              this.historyIndex = this.historyList.length - 1;
              this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
              this.$Store.dispatch("onchangSetnaviName", e.name);
              this.$Store.dispatch("onchangIsfirst", false);
              this.$router.push("/home/" + e.code);
            } else {
              this.$alert("该账号暂无此权限", "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          } else {
            this.$alert(res.data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
          }
        });
      },
      historyTo(e, index) {
        this.historyIndex = index;
        if(e.fnaviid == 9271){
          this.$router.push("/home/" + e.fnaviid);
        }else{
          this.$router.push("/home/" + e.code);
        }
        
        this.$Store.dispatch("onchangIsfirst", false);
        this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
        this.$Store.dispatch("onchangSetnaviName", e.name);
      },
      toPage(data) {
        this.log("data", data);
        const e = JSON.parse(JSON.stringify(data));
        let isHave = false;
        this.historyList.forEach((el, index) => {
          if (el.code == e.code) {
            isHave = true;
            this.historyIndex = index;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            if(e.fnaviid == 9271){
              this.$router.push("/home/" + e.fnaviid);
            }else{
              this.$router.push("/home/" + e.code);
            }
          }
        });
        if (!isHave) {
          this.toauthpage(e);
        }
      },
      toPage2(data) {
        this.log("data", data);
        const e = JSON.parse(JSON.stringify(data));
        let isHave = false;
        this.historyList.forEach((el, index) => {
          if (el.code == e.code) {
            isHave = true;
            this.historyIndex = index;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", true);
            if(e.fnaviid == 9271){
              this.$router.push("/home/" + e.fnaviid);
            }else{
              this.$router.push("/home/" + e.code);
            }
          }
        });
        if (!isHave) {
          this.toauthpage(e);
        }
      },
      changeIsshow() {
        this.isshow = !this.isshow;
        if (this.$refs.rout.$refs.page) {
          if (this.$refs.rout.$refs.page.$refs.bill) {
            this.$refs.rout.$refs.page.$refs.bill.shuaxinTableTop();
            this.$refs.rout.$refs.page.$refs.bill.shuaxinTableThree();
          }
        }
        if (this.isshow) {
          this.mainWidth = window.innerWidth - 150;
          this.$Store.dispatch("onchangLeftWidth", 150);
        } else {
          this.mainWidth = window.innerWidth - 50;
          this.$Store.dispatch("onchangLeftWidth", 50);
        }
      },
      /**个人信息 */
      getdata(data) {
        let that = this;
        if (data == "closeAll") {
          // 关闭所有窗口
          that.tabLists = [];
        } else if (data == "closeMe") {
          // 关闭当前窗口
          that.closeCurrentPage(that.tabSelect);
        } else {}
      },
      /**关闭当前页面 */
      closeCurrentPage(i) {
        this.closeNow();
        return;
        let index = this.findIn(i, this.tabLists); // 获取当前页面下标
        this.tabLists.splice(index, 1); // 删除当前页面
        let numIndex = this.tabLists.length - 1; // 获取历史记录最后一个页面下标
        this.selectMenu(this.tabLists[numIndex]); // 触发跳转到历史记录最后一页
      },

      //查找下标事件
      findIn(i, arr) {
        let index = arr.findIndex((tag) => {
          return i == tag;
        });
        return index;
      },
      toHelp() {
        let obj = {
          code: "bzzx",
          fnaviid: 9996,
          name: "帮助中心"
        };
        this.toPage(obj);
      },
      // 选中top 事件
      selectEvent(i) {
        if (i.title == "主页") {
          this.asideShow = false;
          this.leftSelectArray = [];
          this.$router.push("/home");
        } else {
          this.asideShow = true;
        }

        let obj = {
          fname: i.title,
          fnaviid: i.gid,
        }; // 处理top list 方便 历史记录组件渲染
        this.tabLists = [obj]; // 记录top 模块到历史记录数组中
        this.topSelectArray = [i.title]; // 选中的top
        this.sort_books = i.children; // 选中top下的子集数组
      },
      // 切换页面
      toWhichPage(i) {
        this.log("zhes ", i);
      },
      // 选中left 事件
      selectMenu(i) {
        if (!this.tabLists) {
          this.tabLists = [];
        }
        let index = this.findIn(i, this.tabLists);
        if (index == -1) {
          this.tabLists.push(i);
        } else {
          this.tabLists.splice(index, 1, i);
        }
        this.tabSelect = i;
        // this.tabLists[1] = i
        this.leftSelectArray = [i.fname];
        if (this.topSelectArray.includes("决策分析")) {
          // 路由另处理，因为是动态数据报表
        } else {
          for (let item of this.sort_books) {
            if (item.fname == i.fname && item.fnaviid == i.fnaviid) {
              this.$router.push("/home/" + i.fnaviid);
              this.$Store.dispatch("onchangSetnaviid", i.fnaviid);
              this.$Store.dispatch("onchangSetnaviName", i.name);
            }
          }
        }
      },
      /**监听页面刷新*/
      listenPage() {
        let that = this;
        window.onbeforeunload = function(e) {
          e = e || window.event;
          // let token = localStorage.hasOwnProperty('agttoken')?localStorage.getItem('agttoken'):'';
          // if(!token){//如果没有令牌就跳转到登录页面
          //   that.$router.push("/home")
          // }
        };
      },
      /**确认用户登录的密码*/
      confirmUserInput() {
        this.$axios.post("auth/token", {
            mobile: this.uPhone,
            userpass: this.userInputPwd,
            visit: "web",
            system: "agt",
            gocid: this.gocid,
            version: version,
            linkid: this.flinkid
          }).then(({data}) => {
            if (data.code == 0) {
              this.userInputPwd = "";
              this.inputPwdVisibile = false;
              localStorage.setItem("agttoken", data.data.token);
              localStorage.setItem("agtuserinfo", JSON.stringify(data));
            } else {
              this.$alert(data.message, "错误提示", {confirmButtonText: '确定', type: "error"});
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "./home";

  .home {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /deep/ .vxe-modal--wrapper .vxe-modal--header {
    background: #1c6876 !important;
    color: #fff;
    font-size: 13px;
  }

  /deep/ .vxe-modal--wrapper .vxe-modal--content {
    padding: 6px 4px !important;
  }

  .pwdboxs {
    width: 98%;
    // height: 98%;
    border: 1px solid #888;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .boxTpo {
      width: 100%;
      height: 90px;
      // border-bottom: 1px solid #888;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .boxTpo_item {
        width: 100%;
        height: 50%;
        display: flex;
        border-bottom: 1px solid #888;
        justify-content: space-between;
        align-items: center;

        .boxTpo_item_left {
          width: 30%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #888;
          color: #000;
        }

        .boxTpo_item_right {
          width: 70%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .boxTtn {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }

  .models {
    width: 99%;
    // height: 98%;
    border: 1px solid #999;

    .model-b {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue